<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :handelAdd="handelExport"
      addText="导出"
      :ableSearch="ableSearch"
      :ableAdd="true"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record.visit_area, Enum.areaType.value) }}
        </template>
        <template v-else-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
<!--        <template v-else-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            &nbsp;&nbsp;
            <a-button @click="showHandelAlarmModal(record)" v-if="ableDeal">告警处理</a-button>
          </span>
        </template>-->
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  // import { getData, alarmDeal, getDetail } from '@/api/stranded_management/car'
  import { getData } from '@/api/system_report/vehicle_registration_approval_record'
  // import action from './action'
  // import handelAlarm from './action/handelAlarm.vue'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import { fileExportPost } from '@/utils/download'
  import { resultOptions } from '@/utils/common'
  //初始化
  const pageName = '车辆备案审批记录'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'vrar')
  )
  // const ableDeal = computed(() =>
  //   !!permissionList.value?.find(item => item.code === 'strandedManagementCar:deal')
  // )

  //1、搜索框
  const formCollection = [
    {
      type: 'dateRange',
      startField: 'start_date',
      endField: 'end_date',
      defaultStart: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      defaultEnd: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      label: '审核时间',
    },
    {
      type: 'input',
      field: 'user_name',
      label: '审批人姓名',
      'allowClear': true,
    },
    {
      type: 'select',
      field: 'result',
      options: constantToOptions(resultOptions),
      // defaultValue: 1,
      label: '审批结果',
      width: '120px',
      'allowClear': true,
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
      'allowClear': true,
    },
    /*{
      type: 'select',
      field: 'visit_area',
      storeOptions: 'areaType',
      // defaultValue: 1,
      label: '申请园区',
      width: '130px',
      'allowClear': true,
    },*/
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState,
    }
    store.commit('search/setVehicleRegistrationApprovalRecord', params)
  }

  //2、表格
  const columns = [
    {
      title: '备案单号',
      dataIndex: 'application_number',
      key: 'application_number',
      align: 'left',
    },
    {
      title: '园区类型',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '审批人姓名',
      dataIndex: 'user_name',
      key: 'user_name',
      align: 'left',
    },
    {
      title: '审批人所在部门',
      dataIndex: 'depart_name',
      key: 'depart_name',
      align: 'left',
    },
    {
      title: '审批结果',
      dataIndex: 'result_str',
      key: 'result_str',
      align: 'left',
    },
    {
      title: '审批时间',
      dataIndex: 'approve_time',
      key: 'approve_time',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }

  const cachedSearchParams = computed(() =>
    store.state.search.searchVehicleRegistrationApprovalRecord)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //导出
  const exporting = ref(false)
  async function handelExport() {
    exporting.value = true
    const formState = searchFormRef.value?.formState
    fileExportPost({
      onFinally: () => (exporting.value = false),
      name: `车辆备案审批记录导出.xlsx`,
      url: `/api/statistics/approvalRecord/vehicleRegistrationExport`,
      data: formState,
    })
  }
</script>
